import { createFileRoute, redirect } from '@tanstack/react-router'

// Old links to the sandbox's playground tab open the guide; the search (`?code=`) and hash carry over.
export const Route = createFileRoute('/_app/account/integrations/$appId/playground')({
  beforeLoad: ({ location }) => {
    const url = new URL(location.publicHref, 'http://x')
    throw redirect({ href: `/account/integrations/guide${url.search}${url.hash}`, replace: true, statusCode: 301 })
  },
})
